import { createStyles } from "@raisesistemas/ds"

export const useStyles = createStyles(({ fn }) => ({
  muteAllContainer: {
    backgroundColor: fn.variant({ variant: "light", color: "gray" }).background,
    padding: "10px 8px",
    borderRadius: 10
  }
}))
